/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTxt = createReactComponent("txt", "IconTxt", [
  ["path", { d: "M3 8h4", key: "svg-0" }],
  ["path", { d: "M5 8v8", key: "svg-1" }],
  ["path", { d: "M17 8h4", key: "svg-2" }],
  ["path", { d: "M19 8v8", key: "svg-3" }],
  ["path", { d: "M10 8l4 8", key: "svg-4" }],
  ["path", { d: "M10 16l4 -8", key: "svg-5" }]
]);

export { IconTxt as default };
//# sourceMappingURL=IconTxt.js.map
